import React, { useState } from "react";
import styled from "styled-components";
import oh from "output-helpers";
import { Link } from "react-router-dom";

import ErrorDialog from "../components/ErrorDialog";
import Input from "./Input";
import Button from "./Button";

type onSubmitProps = {
  password: string;
  password_confirm: string;
};

interface ResetPasswordFormProps {
  disabled?: boolean;
  onSubmit: (values: onSubmitProps) => void;
  error_message: string;
  onCloseErrorMessage: any;
}

const Container = styled.div``;

export default ({
  disabled,
  onSubmit,
  error_message,
  onCloseErrorMessage
}: ResetPasswordFormProps) => {
  let [password, setPassword] = useState("");
  let [password2, setPassword2] = useState("");
  let [focus, setFocus] = useState(false);

  const onFocusChange = (is_focus: boolean) => {
    setFocus(is_focus);
  };

  const onKeyUp = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && focus) {
      onSubmit({ password, password_confirm: password2 });
    }
  };

  return (
    <Container onKeyUp={onKeyUp}>
      <div className="form_inputs">
        <Input
          type="password"
          placeholder={oh.translate("password")}
          value={password}
          onChange={setPassword}
          onFocusChange={onFocusChange}
        />
        <br />
        <Input
          type="password"
          placeholder={oh.translate("confirm_password")}
          value={password2}
          onChange={setPassword2}
          onFocusChange={onFocusChange}
        />
      </div>
      {error_message && (
        <ErrorDialog
          error_message={error_message}
          onClose={onCloseErrorMessage}
        />
      )}
      <div className="form_actions">
        <Button
          disabled={disabled}
          text={oh.translate("save")}
          onClick={() => onSubmit({ password, password_confirm: password2 })}
        />
        <br />
        <br />
        <Link to="/">{oh.translate("cancel")}</Link>
      </div>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/components/PasswordResetForm.tsx